"use client";

import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function InstitutionalPartners() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll<HTMLDivElement>({
    threshold: 0.1
  });
  const partners = [{
    name: "Interpol",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728123/img/partner_interpol.png"
  }, {
    name: "Europol",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728123/img/partner_europol.png"
  }, {
    name: "Chainalysis",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728123/img/partner_chainalysis.png"
  }, {
    name: "FBI",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728123/img/partner_fbi.png"
  }, {
    name: "UNODC",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728123/img/partner_unodc.png"
  }, {
    name: "TRM Labs",
    logo: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1728123/img/partner_trm.png"
  }];
  const marqueeItems = [...partners, ...partners];
  return <section data-section-id="2945" id="institutional-trust" className="bg-background text-foreground border-t border-b border-border py-20 md:py-[120px] px-4 overflow-hidden">
      <div ref={ref} className={`max-w-7xl mx-auto transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-4"}`}>
        {}
        <div className="flex items-center justify-center gap-4 mb-12 md:mb-16">
          <span className="inline-block w-1.5 h-1.5" style={{
          backgroundColor: "var(--primary)",
          boxShadow: "0 0 12px var(--primary)"
        }} aria-hidden="true" />
          <p className="font-default text-[12px] uppercase text-muted-foreground text-center" style={{
          letterSpacing: "0.2em"
        }}>
            Trusted by Global Intelligence Agencies
          </p>
          <span className="inline-block w-1.5 h-1.5" style={{
          backgroundColor: "var(--primary)",
          boxShadow: "0 0 12px var(--primary)"
        }} aria-hidden="true" />
        </div>

        {}
        <div className="relative w-full overflow-hidden group">
          {}
          <div className="pointer-events-none absolute left-0 top-0 bottom-0 w-24 md:w-40 z-10" style={{
          background: "linear-gradient(to right, var(--background) 0%, transparent 100%)"
        }} aria-hidden="true" />
          <div className="pointer-events-none absolute right-0 top-0 bottom-0 w-24 md:w-40 z-10" style={{
          background: "linear-gradient(to left, var(--background) 0%, transparent 100%)"
        }} aria-hidden="true" />

          <div className="flex items-center marquee-track">
            {marqueeItems.map((partner, i) => <div data-index={i} key={`${partner.name}-${i}`} className="relative flex items-center justify-center shrink-0 px-8 md:px-14 py-4 partner-item group/item">
                {}
                <span className="absolute right-0 top-1/2 -translate-y-1/2 h-8 w-px bg-border" aria-hidden="true" />

                {}
                <span className="absolute top-0 left-1/2 -translate-x-1/2 w-1.5 h-1.5 opacity-0 group-hover/item:opacity-100 transition-opacity duration-300" style={{
              backgroundColor: "var(--primary)",
              boxShadow: "0 0 12px var(--primary)"
            }} aria-hidden="true" />

                <img src={partner.logo} data-wvc-srcset={`${partner.logo}-wvc-srcset`} data-wvc-sizes={`${partner.logo}-wvc-sizes`} alt={partner.name} loading="lazy" decoding="async" className="max-h-8 w-auto object-contain opacity-40 group-hover/item:opacity-100 transition-opacity duration-300 brightness-0 invert" style={{
              maxHeight: "32px"
            }} />
              </div>)}
          </div>
        </div>

        {}
        <p className="font-default italic text-base text-center mt-12 md:mt-16 max-w-3xl mx-auto" style={{
        color: "var(--muted-foreground)"
      }}>
          Providing forensic crypto scam database intelligence to Interpol, Europol, and leading global security organizations.
        </p>
      </div>

      <style>{`
        @keyframes terra-marquee-scroll {
          0% {
            transform: translateX(0);
          }
          100% {
            transform: translateX(-50%);
          }
        }
        .marquee-track {
          width: max-content;
          animation: terra-marquee-scroll 50s linear infinite;
          will-change: transform;
        }
        .group:hover .marquee-track {
          animation-play-state: paused;
        }
      `}</style>
    </section>;
}